import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { colors } from '../../Theme/constants';
import PropTypes from 'prop-types';
import iconClose from 'Assets/Images/ic-close.svg';
import { Button } from '../../Components/Button';
import { Link } from 'react-router-dom';
import { ButtonLink } from '../../Components/ButtonLink';
import { useSelect } from '../../Hooks';
import { withRouter } from 'react-router';
import { SearchBar } from 'Components/SearchBar';

const ApplicationsModalStyled = styled.div`
  background-color: ${colors.white};
  position: relative;
  width: 36rem;
  margin: 0 auto;
`;
const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 0.8rem;
`;
const CloseButton = styled.button`
  width: 1.6rem;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;
const Body = styled.div`
  h6 {
    text-align: center;
    font-weight: normal;
  }
  ul {
    margin: 0.8rem 0;
    max-height: 25rem;
    overflow: auto;
    li {
      text-align: center;
      a {
        color: ${colors.black};
        padding: 1.6rem 0;
        font-size: 1.4rem;
        display: block;
        &:hover {
          background-color: ${colors.grey200};
        }
      }
      &.isActive {
        a {
          background-color: ${colors.grey200};
          color: ${colors.blue};
        }
      }
    }
  }
`;
const Foot = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0.8rem 1.6rem;
`;

function ApplicationsModal(props) {
  const { handleClose } = props;
  const { applicationList, currentApplication } = useSelect(
    ({ application }) => ({
      applicationList: application.applicationsSelector,
      currentApplication: application.currentApplicationSelector,
    }),
  );

  const [applications, setApplications] = useState(applicationList);

  return (
    <ApplicationsModalStyled>
      <Head>
        <h5>Applications</h5>
        <CloseButton onClick={handleClose}>
          <img src={iconClose} alt="icon" />
        </CloseButton>
      </Head>
      <Body>
        {applicationList.length > 5 ? (
          <SearchBar
            placeholder="Search your application"
            data={applicationList}
            setData={setApplications}
          />
        ) : null}
        <ul>
          {applications.length > 0 ? (
            applications.map(item => (
              <li
                key={item.application_id}
                className={
                  currentApplication &&
                  currentApplication.application_id === item.application_id
                    ? 'isActive'
                    : ''
                }
              >
                <Link
                  to={`/oauth2/app?appId=${item.application_id}`}
                  onClick={handleClose}
                >
                  {item.application_name}
                </Link>
              </li>
            ))
          ) : (
            <h6>No Application</h6>
          )}
        </ul>
      </Body>

      <Foot>
        <Button
          onClick={handleClose}
          borderRadius={0.5}
          height={3.2}
          fontSize={1.4}
          backgroundColor="transparent"
          color={colors.grey}
        >
          Cancel
        </Button>
        <ButtonLink
          onClick={handleClose}
          borderRadius={0.5}
          height={3.2}
          fontSize={1.4}
          fontWeight={600}
          backgroundColor={colors.yellow}
          color={colors.blue900}
          padding="0 1.2rem"
        >
          <Link to="/oauth2/app/create">Create new App</Link>
        </ButtonLink>
      </Foot>
    </ApplicationsModalStyled>
  );
}

ApplicationsModal.propTypes = {
  handleClose: PropTypes.func,
};

export default withRouter(ApplicationsModal);
